import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notification = _resolveComponent("notification")!
  const _component_push = _resolveComponent("push")!
  const _component_notification_group = _resolveComponent("notification-group")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_localization_provider = _resolveComponent("localization-provider")!

  return (_openBlock(), _createBlock(_component_localization_provider, {
    language: _ctx.kendoLocale,
    key: _ctx.kendoLocale
  }, {
    default: _withCtx(() => [
      _createVNode(_component_notification_group, {
        id: "notification-container",
        style: {"z-index":"10001"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
            return (_openBlock(), _createBlock(_component_push, {
              appear: true,
              key: notification.id,
              class: "notification"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_notification, {
                  type: { style: notification.type, icon: true },
                  closable: true,
                  onClose: ($event: any) => (_ctx.onNotificationClose(notification.id))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(notification.message), 1),
                    (notification.actionLabel)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "notification-action",
                          onClick: _withModifiers(($event: any) => (_ctx.onNotificationAction(notification)), ["prevent"])
                        }, _toDisplayString(notification.actionLabel), 9, _hoisted_1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["type", "onClose"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_notification_group, {
        id: "notification-container-debug",
        style: {"z-index":"10001"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.debugNotifications, (notification) => {
            return (_openBlock(), _createBlock(_component_push, {
              appear: true,
              key: notification.id,
              class: "notification"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_notification, {
                  type: { style: notification.type, icon: true },
                  closable: true,
                  onClose: ($event: any) => (_ctx.onNotificationClose(notification.id))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(notification.message), 1)
                  ]),
                  _: 2
                }, 1032, ["type", "onClose"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      (_ctx.localizationReady)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["language"]))
}